module.exports = __webpack_public_path__ + "img/2.a38e9f65.jpg";